import {i18n} from '@/plugins/i18n';
import {walletTransactionTypeStr, walletTransactionTypeVariant} from "@/constants/walletTransactionType";
import {walletTransactionStatusStr, walletTransactionStatusVariant} from "@/constants/walletTransactionStatus";

export default [
    {
        field: 'id',
        title: i18n.t('label.identifier'),
        sortable: true,
        width: 50,
        type: 'number',
        selector: false,
        textAlign: 'center',
    },
    {
        field: 'amount',
        title: i18n.t('label.amount'),
        sortable: true,
        template: row => {
            return `<span dir="ltr">${row.amount}</span>`;
        },
        textAlign: 'center',
    },
    {
        field: 'status',
        title: i18n.t('label.status'),
        sortable: true,
        template: row => {
            return `
                <span class="badge badge-${walletTransactionStatusVariant(row.status)}">
                    ${walletTransactionStatusStr.get(row.status)}
                </span>
            `;
        },
        textAlign: 'center',
    },
    {
        field: 'wallet',
        title: i18n.t('label.wallet'),
        sortable: false,
        template: row => {
            return `<span><a href="/users/${row.wallet.user_hashid}/details" target="_blank">${row.wallet.title}</a></span>`;
        },
        textAlign: 'center',
    },
    {
        field: 'wage',
        title: i18n.t('label.wage'),
        sortable: false,
        template: row => {
            return `<span dir="ltr">${row.wage}</span>`;
        },
        textAlign: 'center',
    },
    {
        field: 'created_at',
        title: i18n.t('label.created_at'),
        sortable: true,
        textAlign: 'center',
    },
    {
        field: 'type',
        title: i18n.t('label.type'),
        sortable: true,
        template: row => {
            return `<span class="badge badge-${walletTransactionTypeVariant(row.type)}">${walletTransactionTypeStr.get(row.type)}</span>`;
        },
        textAlign: 'center',
    },
]
